import tw, { styled } from "twin.macro";

const Link = styled.a`
    ${tw`underline text-primary hocus:text-primary-dark`}
`;

export default Link;